module.exports = __webpack_public_path__ + "static/media/formsActive.4d0c1fa9.svg";